<div class="allow-cookies" [ngClass]="showNotification ? 'show' : 'hide'">
    <div class="headline">Cookie-Hinweis</div>
    <div class="body">
        Um unsere Website für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies.
    </div>
    <button (click)="onAcceptCookies()" mat-button class="converse">Zustimmen</button>
</div>
